"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireDefault(require("react"));
var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));
var _editorialDocument = _interopRequireDefault(require("../styles/editorial-document.css"));
var _card = _interopRequireDefault(require("./card"));
var _editorialDocument2 = _interopRequireDefault(require("./editorial-document.props/editorial-document.defaultProps"));
var _editorialDocument3 = _interopRequireDefault(require("./editorial-document.props/editorial-document.propTypes"));
/**
 * ## EditorialDocument - component
 *
 * Multi purpose cards that can be inputs or download links
 */

var dataUtils = new _mmcDataUtilities["default"]();
var shouldUseDataOrDefaultProps = dataUtils.shouldUseDataOrDefaultProps,
  handleNestedProp = dataUtils.handleNestedProp;
var EditorialDocument = /*#__PURE__*/function (_React$Component) {
  (0, _inheritsLoose2["default"])(EditorialDocument, _React$Component);
  EditorialDocument.resourceType = function resourceType() {
    return 'EditorialDocument_1_0_0';
  };
  function EditorialDocument(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    _this.state = {
      selected: [0],
      multiSelected: []
    };
    _this.updateCurrentSelected = _this.updateCurrentSelected.bind((0, _assertThisInitialized2["default"])(_this));
    _this.selectedValue = _this.selectedValue.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleMultiType = _this.handleMultiType.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }
  var _proto = EditorialDocument.prototype;
  _proto.handleMultiType = function handleMultiType(value, image, mainHeading) {
    var newValue = value[0];
    var payload = {
      link: {
        url: newValue
      },
      image: image,
      description: {
        mainHeading: mainHeading
      }
    };
    var multiSelected = this.state.multiSelected;
    var multiValue = multiSelected.slice();
    var isSelectedIndex = false;
    multiValue.forEach(function (selected, index) {
      if (selected.link.url === newValue) {
        isSelectedIndex = index;
      }
    });

    // if exists - remove
    if (isSelectedIndex === 0 || isSelectedIndex) {
      multiValue.splice(isSelectedIndex, 1);
      // else = add
    } else multiValue.push(payload);
    this.setState({
      multiSelected: multiValue
    });
    return {
      allSelected: multiValue
    };
  };
  _proto.onFieldChange = function onFieldChange(params) {
    var id = params.id,
      value = params.value,
      image = params.image,
      mainHeading = params.mainHeading,
      type = params.type;
    var handleFieldChange = this.props.handleFieldChange,
      handleMultiType = this.handleMultiType;
    if (type === 'multi') {
      var _handleMultiType = handleMultiType(value, image, mainHeading),
        allSelected = _handleMultiType.allSelected;
      handleFieldChange(id, allSelected);
    } else {
      var data = [{
        link: {
          url: value
        },
        image: image,
        description: {
          mainHeading: mainHeading
        }
      }];
      handleFieldChange(id, data);
    }
  };
  _proto.setInitialState = function setInitialState(fn) {
    if (fn === void 0) {
      fn = function fn() {
        return null;
      };
    }
    this.setState({
      selected: [0]
    }, fn());
  };
  _proto.toggleCheckbox = function toggleCheckbox(currentState, selectedCheckbox) {
    if (currentState.indexOf(selectedCheckbox) >= 0) {
      return currentState.filter(function (el) {
        return el !== selectedCheckbox;
      });
    }
    return [].concat(currentState, [selectedCheckbox]);
  };
  _proto.selectedValue = function selectedValue(type) {
    var selected = this.state.selected;
    if (type === 'multi') {
      return selected;
    }
    return selected[0];
  };
  _proto.radioStateUpdate = function radioStateUpdate(index) {
    this.setState(function () {
      return {
        selected: [index]
      };
    });
  };
  _proto.checkboxStateUpdate = function checkboxStateUpdate(index) {
    var _this2 = this;
    this.setState(function (state) {
      return {
        value: _this2.toggleCheckbox(state.selected, index)
      };
    });
  };
  _proto.updateCurrentSelected = function updateCurrentSelected(index, type) {
    if (type === void 0) {
      type = 'radio';
    }
    if (type === 'radio') {
      this.radioStateUpdate(index);
    }
  };
  _proto.renderColumns = function renderColumns(params) {
    var _this3 = this;
    var columns = params.columns,
      theme = params.theme,
      customCards = params.customCards,
      cardType = params.cardType,
      linkClassArray = params.linkClassArray;
    var id = this.props.id;
    var selected = this.state.selected;
    var cardsToUse = customCards || columns;
    var imageWidth = 480;
    var handleElementFieldChange = function handleElementFieldChange(el) {
      return function (value, image, mainHeading) {
        return _this3.onFieldChange({
          id: id,
          value: value,
          image: image,
          mainHeading: mainHeading,
          type: handleNestedProp(el, 'el.selectStyle')
        });
      };
    };
    return cardsToUse && cardsToUse.map(function (el, i) {
      return /*#__PURE__*/_react["default"].createElement(_card["default"], {
        handleFieldChange: handleElementFieldChange(el),
        key: handleNestedProp(el, 'el.description.mainHeading'),
        order: i,
        selected: selected[0],
        updateInternal: _this3.updateCurrentSelected,
        theme: theme,
        downloadpdfList: handleNestedProp(el, 'el.downloadpdfList'),
        link: handleNestedProp(el, 'el.link.url'),
        linkLabel: handleNestedProp(el, 'el.link.label'),
        linkClasses: linkClassArray,
        mainHeading: handleNestedProp(el, 'el.description.mainHeading'),
        paragraph: handleNestedProp(el, 'el.description.paragraph'),
        image: dataUtils.appendImageTransforms(handleNestedProp(el, 'el.image.image'), imageWidth),
        altText: handleNestedProp(el, 'el.image.altText'),
        selectButton: handleNestedProp(el, 'el.selectButton'),
        selectStyle: cardType || handleNestedProp(el, 'el.selectStyle'),
        downloadPDFText: handleNestedProp(el, 'el.downloadPDFText')
      });
    });
  };
  _proto.render = function render() {
    var _this$props = this.props,
      data = _this$props.data,
      theme = _this$props.theme,
      defaultData = _this$props.defaultData,
      customCards = _this$props.customCards,
      cardType = _this$props.cardType,
      linkClasses = _this$props.linkClasses;
    var componentData = shouldUseDataOrDefaultProps(data, defaultData);
    var columns = componentData.columns;
    var linkClassArray = linkClasses || [];
    return /*#__PURE__*/_react["default"].createElement("fieldset", {
      className: theme['container-fluid'] + " " + _editorialDocument["default"].wrapper
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: theme.row + " " + _editorialDocument["default"].columnsContainer
    }, this.renderColumns({
      columns: columns,
      theme: theme,
      customCards: customCards,
      cardType: cardType,
      linkClassArray: linkClassArray
    })));
  };
  return EditorialDocument;
}(_react["default"].Component);
exports["default"] = EditorialDocument;
EditorialDocument.displayName = 'EditorialDocument';
EditorialDocument.defaultProps = {
  data: _editorialDocument2["default"],
  defaultData: _editorialDocument2["default"],
  theme: {}
};